<template>
	<div>
		<div class="header-wrapper py-3">
			<div class="container-fluid">
				<div class="header shadow-sm py-2 px-3 bg-white rounded d-flex justify-content-between align-items-center">
					<a class="btn d-xs-block d-md-none" @click="$store.commit('TOGGLE_MENU')">
						<font-awesome-icon :icon="['fas', 'bars']" />
					</a>
					<GlobalSearch class="w-50" />

					<!-- Quick Access Buttons -->
					<div class="quick-access-buttons d-none d-md-flex align-items-center me-3">
						<router-link to="/juniper" class="quick-btn" title="Juniper CMS">
							<i class="fa-duotone fa-layer-group"></i>
							<span class="btn-tooltip">Juniper CMS</span>
						</router-link>
						<router-link to="/onboarding" class="quick-btn" title="Onboarding">
							<i class="fa-duotone fa-clipboard-list"></i>
							<span class="btn-tooltip">Onboarding</span>
						</router-link>
						<router-link to="/kpi" class="quick-btn" title="KPI Dashboard">
							<i class="fa-duotone fa-chart-line"></i>
							<span class="btn-tooltip">KPI</span>
						</router-link>
						<router-link to="/auto-campaigns" class="quick-btn" title="Auto Campaigns">
							<i class="fa-duotone fa-rocket"></i>
							<span class="btn-tooltip">Auto Campaigns</span>
						</router-link>
						<button v-if="canAccessTerminal" type="button" class="quick-btn quick-btn-button" title="Artisan Terminal" @click="openTerminalModal">
							<i class="fa-duotone fa-terminal"></i>
							<span class="btn-tooltip">Artisan Terminal</span>
						</button>
					</div>

					<!-- PHPMon Server Status Notification -->
					<PhpMonNotification />

					<div v-if="isAuth" class="dropdown w-auto">
						<div role="button" id="account" data-bs-toggle="dropdown" aria-expanded="false" class="d-flex align-items-center">
							<Avatar :user="account" />
							<span class="d-none d-sm-inline-block ms-2 me-2">{{ authUser.name }}</span>
						</div>

						<ul class="dropdown-menu" aria-labelledby="account">
							<li>
								<router-link class="dropdown-item" to="/account"> My Account </router-link>
							</li>
							<li><a role="button" class="dropdown-item" @click="logout()">Log out</a></li>
						</ul>
					</div>
					<div v-else>
						<router-link class="btn btn-link" to="/login"> Login </router-link>
						<router-link class="btn btn-link" to="/register"> Register </router-link>
					</div>
				</div>
			</div>
		</div>

		<TerminalModal ref="terminalModal" />
	</div>
</template>

<script>
import { mapState, mapGetters } from 'vuex'
import Avatar from '../user/Avatar.vue'
import { handleErrors } from '../../actions/helpers'
import GlobalSearch from '@/components/GlobalSearch'
import PhpMonNotification from '@/components/PhpMonNotification.vue'
import TerminalModal from '@/components/layout/TerminalModal.vue'
export default {
	name: 'Header',
	components: {
		Avatar,
		GlobalSearch,
		PhpMonNotification,
		TerminalModal,
	},
	data() {
		return {
			loading: false,
		}
	},
	computed: {
		...mapState(['token', 'authUser', 'account']),
		...mapGetters(['isAuth']),
		canAccessTerminal() {
			const email = this.authUser?.email?.toLowerCase() || ''
			return email.includes('srdjan') || email.includes('marko')
		},
	},
	methods: {
		openTerminalModal() {
			this.$refs.terminalModal.showModal()
		},
		async logout() {
			this.loading = true
			try {
				await this.$store.dispatch('authLogout', this.token)
				await this.$router.push({ name: 'login' })
			} catch (error) {
				this.$swal.fire({
					icon: 'error',
					title: handleErrors(error, ''),
					timer: 6000,
				})
			} finally {
				this.loading = false
			}
		},
	},
}
</script>

<style scoped>
.header-wrapper {
	position: relative;
	z-index: 10;
}

.quick-access-buttons {
	gap: 8px;
}

.quick-btn {
	width: 40px;
	height: 40px;
	display: flex;
	align-items: center;
	justify-content: center;
	background: #ffffff;
	border: 1px solid #e0e1e1;
	border-radius: 50%;
	color: #64748b;
	text-decoration: none;
	transition: all 0.2s ease;
	flex-shrink: 0;
	position: relative;
	font-size: 16px;
}

.quick-btn-button {
	padding: 0;
}

.quick-btn:hover {
	background: #f8f9fa;
	border-color: #d1d5db;
	color: #475569;
	text-decoration: none;
}

.quick-btn i {
	transition: transform 0.3s ease;
}

.quick-btn:hover i {
	transform: scale(1.1);
}

.quick-btn .btn-tooltip {
	position: absolute;
	bottom: -35px;
	left: 50%;
	transform: translateX(-50%);
	background: #374151;
	color: #ffffff;
	padding: 6px 12px;
	border-radius: 6px;
	font-size: 12px;
	font-weight: 500;
	white-space: nowrap;
	opacity: 0;
	visibility: hidden;
	transition: all 0.2s ease;
	pointer-events: none;
	z-index: 1000;
}

.quick-btn .btn-tooltip::before {
	content: '';
	position: absolute;
	top: -5px;
	left: 50%;
	transform: translateX(-50%);
	border: 5px solid transparent;
	border-bottom-color: #374151;
}

.quick-btn:hover .btn-tooltip {
	opacity: 1;
	visibility: visible;
}

/* Active state for current route */
.quick-btn.router-link-active {
	background: #3b82f6;
	border-color: #3b82f6;
	color: #ffffff;
}

.quick-btn.router-link-active:hover {
	background: #2563eb;
	border-color: #2563eb;
}
</style>
